
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./formik.cjs.production.min.js')
} else {
  module.exports = require('./formik.cjs.development.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/formik/dist/index.js
// module id = 150
// module chunks = 0